// ═══════════════════════════════════════════════════════════════
//  replis.js — mémoire des sections / groupes dépliés de l'écran Tâches (T16)
//
//  ⚠️ CE FICHIER N'IMPORTE RIEN, ET C'EST VOLONTAIRE — même parti pris que
//  workflow.js : replis.test.js l'importe en `node` pur.
//  Le stockage est INJECTÉ, jamais `localStorage` en dur : le module doit
//  rester chargeable par node, et un navigateur en navigation privée (ou aux
//  données de site bloquées) JETTE dès l'accès à `window.localStorage`.
//  Une préférence d'affichage perdue n'est jamais une erreur : tout échec de
//  lecture rend un Set vide, tout échec d'écriture est avalé.
// ═══════════════════════════════════════════════════════════════

// Groupes de chantier DÉPLIÉS (clé = chantierId). Absent = replié : c'est le
// défaut voulu, la liste « Mes chantiers » était interminable.
export const CLE_REPLIS = "epj.taches.ouverts";

// Cartes de section REPLIÉES (clé = id de section). Sémantique INVERSE, et
// clé de stockage distincte : une carte est dépliée par défaut — replier
// « Mes tâches » dès la première visite cacherait l'essentiel de l'écran.
export const CLE_SECTIONS_REPLIEES = "epj.taches.sectionsRepliees";

// Accès protégé à un stockage du navigateur (`"localStorage"`,
// `"sessionStorage"`) : le simple accesseur peut jeter. Renvoie null hors
// navigateur ou sur refus — les fonctions ci-dessous l'acceptent.
export function stockageNavigateur(nom) {
  try {
    return globalThis[nom] || null;
  } catch {
    return null;
  }
}

// → Set de chaînes. Vide si le stockage est absent, jette, ou contient autre
// chose qu'un tableau JSON.
export function chargerOuverts(storage, cle = CLE_REPLIS) {
  try {
    const brut = storage ? storage.getItem(cle) : null;
    if (!brut) return new Set();
    const tab = JSON.parse(brut);
    return new Set(Array.isArray(tab) ? tab.filter((x) => typeof x === "string" && x) : []);
  } catch {
    return new Set();
  }
}

// Ne jette jamais (quota plein, navigation privée, stockage absent).
export function enregistrerOuverts(storage, set, cle = CLE_REPLIS) {
  try {
    if (!storage) return;
    storage.setItem(cle, JSON.stringify([...(set || [])]));
  } catch {
    /* préférence d'affichage : perdue sans conséquence */
  }
}

// → NOUVEAU Set, l'entrée n'est jamais mutée (un Set muté en place ne
// déclencherait pas de rendu React).
export function basculerOuvert(set, cle) {
  const suivant = new Set(set || []);
  if (suivant.has(cle)) suivant.delete(cle); else suivant.add(cle);
  return suivant;
}
